export default __webpack_public_path__ + "static/media/logo-name.702cfb32.svg";